import { render, staticRenderFns } from "./SetCaseContent.vue?vue&type=template&id=19747cef&scoped=true"
import script from "./SetCaseContent.vue?vue&type=script&lang=js"
export * from "./SetCaseContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19747cef",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/ap/jenkins/workspace/prod-ykd360-admin-front(医可达旧管理端)/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19747cef')) {
      api.createRecord('19747cef', component.options)
    } else {
      api.reload('19747cef', component.options)
    }
    module.hot.accept("./SetCaseContent.vue?vue&type=template&id=19747cef&scoped=true", function () {
      api.rerender('19747cef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/seekBeauty/setCase/SetCaseContent.vue"
export default component.exports